import axios from "axios";

export default {
  methods: {
    async openProduct(
      coloredProduct,
      size,
      categoryId,
      abStatisticsTitle,
      recommendedProduct,
      lastSeenProduct
    ) {
      if (window.productListDatalayerEventData) {
        try {
          let universalAnalyticsProductData;
          let ga4ProductData;
          if (coloredProduct.product.eso_id) {
            universalAnalyticsProductData = window.productListDatalayerEventData.universalAnalyticsData.ecommerce.impressions.find(
              (item) => item.id == coloredProduct.product.eso_id
            );
            ga4ProductData = window.productListDatalayerEventData.ga4Data.items.find(
              (item) => item.item_id == coloredProduct.product.eso_id
            );
          }
          if (coloredProduct.esoId) {
            universalAnalyticsProductData = window.productListDatalayerEventData.universalAnalyticsData.ecommerce.impressions.find(
              (item) => item.id == coloredProduct.esoId
            );
            ga4ProductData = window.productListDatalayerEventData.ga4Data.items.find(
              (item) => item.item_id == coloredProduct.esoId
            );
          }

          const universalAnalyticsEventData = {
            event: "eec.impressionClick",
            ecommerce: {
              click: {
                actionField: { list: "Category" },
                products: [universalAnalyticsProductData],
              },
            },
          };
          // console.log("🚀 ~ file: open-product-mixin.js ~ line 19 ~ openProduct ~ universalAnalyticsEventData", universalAnalyticsEventData)

          const ga4AnalyticsEventData = {
            event: "select_item",
            item_list_name: "Category",
            items: [ga4ProductData],
          };

          // console.log("🚀 ~ file: open-product-mixin.js ~ line 26 ~ openProduct ~ ga4AnalyticsEventData", ga4AnalyticsEventData)

          window.dataLayer.push(universalAnalyticsEventData);
          window.dataLayer.push(ga4AnalyticsEventData);

          //   if (lastSeenProduct) {
          //     console.log("last seen");
          //     sendGoogleAnalyticsEvent();
          //   }

          if (recommendedProduct && coloredProduct.esoId) {
            sendGoogleAnalyticsEvent("recommended_product_card_clicked", {
              // 'source_product_eso_id': coloredProduct.esoId,
              destination_product_eso_id: coloredProduct.esoId,
            });
          }
        } catch (error) {
          console.log("Problem with datalayer.");
        }
      }
      if (categoryId) {
        localStorage.setItem("category-" + categoryId, coloredProduct.id);
      }

      if (abStatisticsTitle) {
        await this.$http
          .put("/ab-statistics-product", {
            title: abStatisticsTitle,
          })
          .then((res) => {})
          .catch((error) => {
            console.log(error);
          });
      }

      const link =
        "/" +
        coloredProduct.slug +
        (size ? `?${window.__("frontend_js.routes.size")}=` + size : "");

      setTimeout(() => {
        window.location.href = link;
      }, 50);
    },

    getHrefLink(coloredProduct, size) {
      const link =
        "/" +
        coloredProduct.slug +
        (size ? `?${window.__("frontend_js.routes.size")}=` + size : "");
      return link;
    },
  },
};
